//@ts-check
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import React from 'react'
import styles from "./InteractiveDialog.module.css"
import ButtonHLPure from '../buttonHL/buttonHL.pure';

/**
 * @typedef {object} Props
 * @property {() => void} [onClose] - Callback function to handle dialog close
 * @property {import('react').MouseEventHandler<HTMLButtonElement>} [onSave] - Callback function to handle dialog save
 * @property {string} [saveBtnTitle] - Title for the save button (default: 'Save')
 * @property {string} [cancelBtnTitle] - Title for the cancel button (default: 'Cancel')
 * @property {React.ReactNode} children - The content to be displayed inside the dialog
 * @property {string} title - Title of the dialog
 * @property {string} [buttonClassname] - Custom class name for the buttons
 * @property {React.ReactNode} [CustomButtons] - Custom buttons to be displayed in the dialog actions bar 
 */

const DIALOG_COLLABORATOR_WIDTH = 580;

/**
 * @param {import('@progress/kendo-react-dialogs').DialogProps & Props} props
 */
const InteractiveDialog = ({ onClose, onSave, saveBtnTitle, cancelBtnTitle, title, children, buttonClassname, CustomButtons, ...props }) => {
    return (
        <>
            <Dialog
                className={styles[`InteractiveDialog-container`]}
                width={DIALOG_COLLABORATOR_WIDTH}
                height={'auto'}
                title={title}
                onClose={onClose}
                {...props}
            >
                <div className={styles['InteractiveDialog-content']}>
                    {children}
                </div>
                {(CustomButtons || cancelBtnTitle || saveBtnTitle) && (
                    <DialogActionsBar>
                        <div className={!buttonClassname ? styles["InteractiveDialog-actions"] : buttonClassname}>
                            {CustomButtons ? <>
                                {CustomButtons}
                            </>
                                :
                                <>
                                    {cancelBtnTitle && <ButtonHLPure nameBtn={cancelBtnTitle} onClickBtn={onClose} />}
                                    {saveBtnTitle && <ButtonHLPure nameBtn={saveBtnTitle} primary onClickBtn={onSave} />}
                                </>
                            }
                        </div>
                    </DialogActionsBar>
                )}
            </Dialog>
        </>
    )
}

export default InteractiveDialog